import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';

export const slideInDoors = trigger('slideInDoors', [
  state('in', style({ transform: 'translateX(0)' })),
  transition('void => *', [
    animate(150, keyframes([style({ transform: 'translateX(-100%)' }), style({ transform: 'translateX(0)' })])),
  ]),
  transition('* => void', [
    animate(150, keyframes([style({ transform: 'translateX(0)' }), style({ transform: 'translateX(-100%)' })])),
  ]),
]);
